import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosApiInstance from "app/services/axios";
import { DATASOURCE_CONFIG } from "app/config";
import { convertStringToInt, tabDataQuery } from "./reportingQueryUtill";
import {
  dataStoreRealTimeTable,
  eventHourlyReportingTable,
  getDataEndPoint,
  getRegionIDReportingDataEndPoint,
  getReportingDataEndPoint,
} from "app/utils/constants/paths";
import moment from "moment";
import { REPORTING_INHOUSE_DSPS } from "app/utils/constants/configurations";
import cloneDeep from "lodash.clonedeep";
let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const normalizeReportCampaignIds = (reportCampaignId) => {
  if (Array.isArray(reportCampaignId)) {
    return reportCampaignId
      .map((id) => `${id}`.trim())
      .filter((id) => id != "");
  }
  if (reportCampaignId != null && reportCampaignId != "") {
    return `${reportCampaignId}`
      .split(",")
      .map((id) => id.trim())
      .filter((id) => id != "");
  }
  return [];
};

const initialState = {
  loading: false,
  tileLoading: false,
  reportingTabsData: {},
  tabLoaders: [],
  bannersList: {},
  stateList: [],
  pincodesList: [],
};

const CampaignAllReport = createSlice({
  name: "CampaignAllReport",
  initialState,
  reducers: {
    // resetAnalyticsDashboardSliceData(state, action) {
    //     state.graphData = {};
    //     state.tilesData = {};
    //     state.dashboardPreInfo = [];
    //   },
    //   updateDashboardType(state, action) {
    //     state.dashboardType = action.payload.dashboardType;
    //   },

    updateTabLoaders(state, action) {
      state.tabLoaders.push(action.payload);
    },
    sortCreativesData(state, action) {
      let sortby = action.payload.sortby;
      let creativesData = cloneDeep(
        state.reportingTabsData?.creative_creative?.raw?.data
      );
      creativesData.sort((a, b) => b?.[sortby] - a?.[sortby]);
      state.reportingTabsData.creative_creative.raw.data = creativesData;
    },
    resetReportingData(state, action) {
      state.reportingTabsData = {};
      state.tabLoaders = [];
      state.bannersList = {};
      state.stateList = [];
    },
  },

  extraReducers(builder) {
    builder
      .addCase(GetCampaignAllReportingTabsDataThunk.pending, (state) => {
        state.dashboardPreInfoLoader = true;
      })
      .addCase(
        GetCampaignAllReportingTabsDataThunk.fulfilled,
        (state, action) => {
          const dbResponse = action.payload.data.results;
          if (dbResponse && dbResponse.length) {
            let finalDataObj = dbResponse[0];
            if (
              finalDataObj.length > 0 &&
              (action.meta.arg.tab == "creative_creative" ||
                action.meta.arg.tab == "campaign_day" ||
                action.meta.arg.tab == "campaign_dayofweek")
            ) {
              for (let k = 0; k < finalDataObj.length; k++) {
                finalDataObj[k]["ctr"] =
                  finalDataObj[k]["impressions"] == 0
                    ? 0
                    : Math.round(
                        (finalDataObj[k]["clicks"] /
                          finalDataObj[k]["impressions"]) *
                          100 *
                          100
                      ) / 100;

                finalDataObj[k]["vcr"] =
                  finalDataObj[k]["impressions"] == 0
                    ? 0
                    : Math.round(
                        (finalDataObj[k]["complete"] /
                          finalDataObj[k]["impressions"]) *
                          100 *
                          100
                      ) / 100;

                // finalDataObj[k]["conversion_cost_gross"] =
                //   finalDataObj[k]["conversions"] > 0 &&
                //   finalDataObj[k]["impressions"] > 0
                //     ? Math.round(
                //         (finalDataObj[k]["impressions"] /
                //           finalDataObj[k]["conversions"]) *
                //           (finalDataObj[k]["spend"] /
                //             finalDataObj[k]["impressions"]) *
                //           100
                //       ) / 100
                //     : 0;

                // finalDataObj[k]["conversion_cost_net"] =
                //   finalDataObj[k]["conversions"] > 0 &&
                //   finalDataObj[k]["impressions"] > 0
                //     ? Math.round(
                //         (finalDataObj[k]["impressions"] /
                //           finalDataObj[k]["conversions"]) *
                //           (finalDataObj[k]["net"] /
                //             finalDataObj[k]["impressions"]) *
                //           100
                //       ) / 100
                //     : 0;
              }
              //finalDataObj = convertStringToInt(finalDataObj, []);
            } else if (
              finalDataObj.length > 0 &&
              ((action.meta.arg.tab == "device_type" &&
                action.meta.arg.action == "ctr") ||
                (action.meta.arg.tab == "everything" &&
                  action.meta.arg.action == "ctr") ||
                (action.meta.arg.tab == "device_os" &&
                  action.meta.arg.action == "ctr") ||
                (action.meta.arg.tab == "campaign_daypart" &&
                  action.meta.arg.action == "ctr"))
            ) {
              for (let k = 0; k < finalDataObj.length; k++) {
                finalDataObj[k]["ctr"] =
                  finalDataObj[k]["impressions"] == 0
                    ? 0
                    : Math.round(
                        (finalDataObj[k]["clicks"] /
                          finalDataObj[k]["impressions"]) *
                          100 *
                          100
                      ) / 100;
              }
              finalDataObj.sort((a, b) => b?.["ctr"] - a?.["ctr"]);

              //If array contains more than 10 objects then take first 10 objects
              if (finalDataObj.length > 10) {
                finalDataObj = finalDataObj.slice(0, 10);
              }
              //finalDataObj = convertStringToInt(finalDataObj, []);
            }
            finalDataObj = convertStringToInt(finalDataObj, []);

            if (state.reportingTabsData[action.meta.arg.tab]) {
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                data: finalDataObj,
                updatedAt: moment().format("x"),
              };

              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");
            } else {
              state.reportingTabsData[action.meta.arg.tab] = {};
              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");

              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                data: finalDataObj,
                updatedAt: moment().format("x"),
              };
            }
            if (
              state.tabLoaders.indexOf(
                action.meta.arg.tab + "_" + action.meta.arg.action
              ) != -1
            ) {
              state.tabLoaders.splice(
                state.tabLoaders.indexOf(
                  action.meta.arg.tab + "_" + action.meta.arg.action
                ),
                1
              );
            }
          }
          state.tileLoading = false;
        }
      )
      .addCase(GetCampaignAllReportingTabsDataThunk.rejected, (state) => {
        // state.dashboardPreInfoLoader = false;
      })
      .addCase(GetReportingOverviewSummaryDataThunk.pending, (state) => {
        state.tileLoading = true;
      })
      .addCase(
        GetReportingOverviewSummaryDataThunk.fulfilled,
        (state, action) => {
          const dbResponse = action.payload.data.results;
          const reportCampaignId = action.meta.arg?.reportCampaignId;
          if (dbResponse && dbResponse.length) {
            // if (dbResponse.length > 1) {
            //   let summaryObj = dbResponse[0][0];
            //   let availsObj = dbResponse[1][0];
            //   console.log("availsObj", availsObj);
            //   if (availsObj?.available) {
            //     summaryObj.available =
            //       availsObj?.available > 0 ? availsObj?.available : 0;
            //   }
            //   if (availsObj?.qualify) {
            //     summaryObj.qualify =
            //       availsObj?.qualify > 0 ? availsObj?.qualify : 0;
            //   }
            //   console.log("summaryObj", summaryObj);
            //   state.reportingTiles = summaryObj;
            // } else {
            //   state.reportingTiles = dbResponse[0][0];
            // }

            let dbSumArrObj = cloneDeep(dbResponse[0]);
            let dbAvailsArrObj =
              dbResponse.length > 1 ? cloneDeep(dbResponse[1]) : [];

            let summaryArr = convertStringToInt(dbSumArrObj, []);
            let availsArr =
              dbResponse.length > 1
                ? convertStringToInt(dbAvailsArrObj, [])
                : {};

            if (state.reportingTabsData[action.meta.arg.tab]) {
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: summaryArr[0],
                avails_data: dbResponse.length > 1 ? availsArr[0] : {},
                updatedAt: moment().format("x"),
              };

              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");
            } else {
              //let summaryArr = convertStringToInt(dbResponse[0], []);
              let dbSumArrObj = cloneDeep(dbResponse[0]);
              let dbAvailsArrObj =
                dbResponse.length > 1 ? cloneDeep(dbResponse[1]) : [];

              let summaryArr = convertStringToInt(dbSumArrObj, []);
              let availsArr =
                dbResponse.length > 1
                  ? convertStringToInt(dbAvailsArrObj, [])
                  : {};

              state.reportingTabsData[action.meta.arg.tab] = {};
              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");

              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: summaryArr[0],
                avails_data: dbResponse.length > 1 ? availsArr[0] : {},
                updatedAt: moment().format("x"),
              };
            }
          } else {
            if (state.reportingTabsData[action.meta.arg.tab]) {
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: {},
                avails_data: {},
                updatedAt: moment().format("x"),
              };

              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");
            } else {
              state.reportingTabsData[action.meta.arg.tab] = {};
              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");

              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: {},
                avails_data: {},
                updatedAt: moment().format("x"),
              };
            }
          }

          if (
            state.tabLoaders.indexOf(
              action.meta.arg.tab + "_" + action.meta.arg.action
            ) != -1
          ) {
            state.tabLoaders.splice(
              state.tabLoaders.indexOf(
                action.meta.arg.tab + "_" + action.meta.arg.action
              ),
              1
            );
          }
        }
      )
      .addCase(
        GetReportingOverviewSummaryDataThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
        }
      )
      .addCase(getCampaignAppliedTargetingDataThunk.pending, (state) => {})
      .addCase(
        getCampaignAppliedTargetingDataThunk.fulfilled,
        (state, action) => {
          const dbResponse = action.payload.data.results;
          if (dbResponse && dbResponse.length) {
            if (state.reportingTabsData[action.meta.arg.tab]) {
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = dbResponse[0][0];
            } else {
              state.reportingTabsData[action.meta.arg.tab] = {};
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = dbResponse[0][0];
            }
            if (
              state.tabLoaders.indexOf(
                action.meta.arg.tab + "_" + action.meta.arg.action
              ) != -1
            ) {
              state.tabLoaders.splice(
                state.tabLoaders.indexOf(
                  action.meta.arg.tab + "_" + action.meta.arg.action
                ),
                1
              );
            }
          }
        }
      )
      .addCase(
        getCampaignAppliedTargetingDataThunk.rejected,
        (state, action) => {}
      )
      .addCase(getStateListDataThunk.pending, (state) => {})
      .addCase(getStateListDataThunk.fulfilled, (state, action) => {
        if (action.payload.data.results.length > 0) {
          state.stateList = action.payload.data.results[0];
        }
      })
      .addCase(getStateListDataThunk.rejected, (state, action) => {})
      .addCase(getCampaignTargetingTabDataThunk.pending, (state) => {})
      .addCase(getCampaignTargetingTabDataThunk.fulfilled, (state, action) => {
        if (action.payload.data.results.length > 0) {
        }
      })
      .addCase(getCampaignTargetingTabDataThunk.rejected, (state, action) => {})
      .addCase(getBannerDetailsThunk.pending, (state) => {
        //state.loading = true;
        //state.bannerLoader = true;
      })
      .addCase(getBannerDetailsThunk.fulfilled, (state, action) => {
        //state.loading = false;
        // state.bannerLoader = false;
        const dbResponse = action.payload.data.results;
        console.log("dbResponse;", dbResponse);
        let bannersObj = {};
        if (dbResponse && dbResponse.length) {
          for (let i = 0; i < dbResponse[0].length; i++) {
            let bind = dbResponse[0][i];
            bannersObj[bind["id"]] = bind;
          }
        }
        state.bannersList = bannersObj;
      })
      .addCase(getBannerDetailsThunk.rejected, (state, action) => {
        state.bannerLoader = false;
      })
      .addCase(getPincodeDetailsDataThunk.pending, (state) => {})
      .addCase(getPincodeDetailsDataThunk.fulfilled, (state, action) => {
        if (action.payload.data.results.length > 0) {
          state.pincodesList = action.payload.data.results[0];
        } else {
          state.pincodesList = [];
        }
      })
      .addCase(getPincodeDetailsDataThunk.rejected, (state, action) => {})
      .addCase(GetCampaignReportByRegionIDDataThunk.pending, (state) => {
        state.tileLoading = true;
      })
      .addCase(
        GetCampaignReportByRegionIDDataThunk.fulfilled,
        (state, action) => {
          const dbResponse = action.payload.data.results;
          const reportCampaignId = action.meta.arg?.campaigns;

          if (action.payload.data.hasData == true) {
            //let clonedDBResult = cloneDeep(dbResponse);
            //delete clonedDBResult["totals"];

            let dbSumArrObj = [cloneDeep(dbResponse?.totals)];
            let dbRegionalArrObj =
              Object.values(dbResponse?.poi_data).length > 0
                ? cloneDeep(Object.values(dbResponse?.poi_data))
                : [];
            let allregions = cloneDeep(dbResponse.all_regions);

            let summaryArr = convertStringToInt(dbSumArrObj, []);
            let regionalDataArr =
              dbRegionalArrObj.length > 0
                ? convertStringToInt(dbRegionalArrObj, [])
                : [];

            //console.log("HERE----------SIDD");
            if (state.reportingTabsData[action.meta.arg.tab]) {
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: summaryArr,
                region_data: regionalDataArr,
                allregions: allregions,
                updatedAt: moment().format("x"),
              };

              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");
            } else {
              state.reportingTabsData[action.meta.arg.tab] = {};
              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");

              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: summaryArr,
                region_data: regionalDataArr,
                allregions: allregions,
                updatedAt: moment().format("x"),
              };
            }
          } else {
            if (state.reportingTabsData[action.meta.arg.tab]) {
              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: {},
                region_data: [],
                updatedAt: moment().format("x"),
              };

              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");
            } else {
              state.reportingTabsData[action.meta.arg.tab] = {};
              state.reportingTabsData[action.meta.arg.tab]["updatedAt"] =
                moment().format("x");

              state.reportingTabsData[action.meta.arg.tab][
                action.meta.arg.action
              ] = {
                summary_data: {},
                region_data: [],
                updatedAt: moment().format("x"),
              };
            }
          }

          if (
            state.tabLoaders.indexOf(
              action.meta.arg.tab + "_" + action.meta.arg.action
            ) != -1
          ) {
            state.tabLoaders.splice(
              state.tabLoaders.indexOf(
                action.meta.arg.tab + "_" + action.meta.arg.action
              ),
              1
            );
          }
        }
      )
      .addCase(
        GetCampaignReportByRegionIDDataThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
        }
      );
  },
});

export const GetCampaignAllReportingTabsDataThunk = createAsyncThunk(
  "report/GetCampaignAllReportingTabsDataThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          //Get Open Requests Query
          query: tabDataQuery(payload.tab, payload.action, payload),
          datasource: "redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetReportingOverviewSummaryDataThunk = createAsyncThunk(
  "report/GetReportingOverviewSummaryDataThunk",
  async (payload) => {
    let userTimeZone = payload.timezone;
    let start_date = payload.start_date;
    let end_date = payload?.end_date;
    let accounts = [];
    let advertisers = [];
    let campaigns = [];
    let banners = [];
    const reportCampaignIds = normalizeReportCampaignIds(
      payload?.reportCampaignId
    );
    const reportCampaignIdsSql =
      reportCampaignIds.length > 0
        ? "'" + reportCampaignIds.join("','") + "'"
        : "";

    if (reportCampaignIds.length > 0) {
      start_date = moment(payload.reportStartDate).format(
        "YYYY-MM-DD 00:00:00"
      );
      end_date =
        payload?.reportEndDate != null &&
        payload?.reportEndDate != "" &&
        payload?.reportEndDate != "0000-00-00 00:00:00"
          ? moment(payload.reportEndDate).format("YYYY-MM-DD 23:59:59")
          : moment
              .tz(
                moment.utc().format("YYYY-MM-DD HH:mm:ss"),
                "YYYY-MM-DD HH:mm:ss",
                "UTC"
              )
              .tz(userTimeZone)
              .format("YYYY-MM-DD 23:59:59");
      accounts = [];
      advertisers = [];
      campaigns = reportCampaignIds;
      banners = [];
    }

    let inhouseDSPStr =
      REPORTING_INHOUSE_DSPS.length > 0
        ? "'" + REPORTING_INHOUSE_DSPS.join("','") + "'"
        : "";

    let WC = [];
    if (start_date != null && start_date != "") {
      WC.push(
        `date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}') `
      );
    }

    if (end_date != null && end_date != "") {
      WC.push(
        `date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}') `
      );
    }

    if (inhouseDSPStr != "") {
      WC.push(`hourly.dspid IN(${inhouseDSPStr})`);
    }
    if (accounts?.length > 0) {
      let accountsStr = "'" + accounts.join("','") + "'";
      WC.push(`hourly.dsp_account_id IN(${accountsStr})`);
    }
    if (advertisers?.length > 0) {
      let advsStr = "'" + advertisers.join("','") + "'";
      WC.push(`hourly.advertiser_id IN(${advsStr})`);
    }
    if (campaigns?.length > 0) {
      let campaignsStr = "'" + campaigns.join("','") + "'";
      WC.push(`hourly.cid IN(${campaignsStr})`);
    }

    if (banners?.length > 0) {
      let bannersStr = "'" + banners.join("','") + "'";
      WC.push(`hourly.crid IN(${bannersStr})`);
    }

    let whrCondition = "";
    if (WC.length > 0) {
      whrCondition = " where " + WC.join(" and ");
    }

    var q =
      "select SUM(A.requests) as requests,SUM(A.impressions) as impressions,SUM(A.viewables) as viewables,SUM(A.uniques) as uniques,SUM(A.clicks) as clicks, SUM(A.datacost) as datacost,SUM(A.attribution_cost) as attribution_cost, SUM(A.margin) as margin, SUM(A.spend) as spend, SUM(A.net) as net,SUM(A.load) as load, SUM(A.start) as start, SUM(A.first_quartile) as first_quartile, SUM(A.mid_point) as mid_point, SUM(A.third_quartile) as third_quartile, SUM(A.complete) as complete,SUM(A.close) as close, SUM(A.conversions) as conversions, SUM(A.roi) as roi,SUM(A.roi_1) as roi_1,SUM(A.roi_2) as roi_2,SUM(A.roi_3) as roi_3,SUM(A.roi_4) as roi_4,SUM(A.conversions_2) as conversions_2,SUM(A.conversions_3) as conversions_3,SUM(A.conversions_4) as conversions_4 from ((select SUM(CASE when EVENT_ID = 0 then total_count ELSE 0 END) as requests,SUM(CASE when EVENT_ID = 1 then total_count ELSE 0 END) as impressions, SUM(CASE when EVENT_ID = 3 then total_count ELSE 0 END) as clicks, SUM(CASE when EVENT_ID = 4 then total_count ELSE 0 END) as conversions, SUM(CASE when EVENT_ID = 5 then total_count ELSE 0 END) as load, SUM(CASE when EVENT_ID = 6 then total_count ELSE 0 END) as start, SUM(CASE when EVENT_ID = 7 then total_count ELSE 0 END) as first_quartile, SUM(CASE when EVENT_ID = 8 then total_count ELSE 0 END) as mid_point, SUM(CASE when EVENT_ID = 9 then total_count ELSE 0 END) as third_quartile, SUM(CASE when EVENT_ID = 10 then total_count ELSE 0 END) as complete, SUM(CASE when EVENT_ID = 11 then total_count ELSE 0 END) as close, SUM(CASE when EVENT_ID = 13 then total_count ELSE 0 END) as viewables,   0 as uniques,SUM(hourly.total_get_from_direct+hourly.attribution_cost_gross) as spend, SUM(hourly.datacost) as datacost, SUM(hourly.attribution_cost_gross) as attribution_cost, SUM(hourly.margin) as margin, SUM(hourly.total_pay_to_pub) as net, SUM(hourly.roi_gross) as roi,SUM(CASE when EVENT_ID = 4 then hourly.roi_gross ELSE 0 END) as roi_1,SUM(CASE when EVENT_ID = 38 then hourly.roi_gross ELSE 0 END) as roi_2,SUM(CASE when EVENT_ID = 39 then hourly.roi_gross ELSE 0 END) as roi_3,SUM(CASE when EVENT_ID = 40 then hourly.roi_gross ELSE 0 END) as roi_4,SUM(CASE when EVENT_ID = 38 then total_count ELSE 0 END) as conversions_2,SUM(CASE when EVENT_ID = 39 then total_count ELSE 0 END) as conversions_3,SUM(CASE when EVENT_ID = 40 then total_count ELSE 0 END) as conversions_4  from " +
      eventHourlyReportingTable +
      "  as hourly  " +
      whrCondition +
      ") union (select SUM(CASE when EVENT_ID = 0 then total_count ELSE 0 END) as requests,SUM(CASE when EVENT_ID = 1 then total_count ELSE 0 END) as impressions, SUM(CASE when EVENT_ID = 3 then total_count ELSE 0 END) as clicks, SUM(CASE when EVENT_ID = 4 then total_count ELSE 0 END) as conversions, SUM(CASE when EVENT_ID = 5 then total_count ELSE 0 END) as load, SUM(CASE when EVENT_ID = 6 then total_count ELSE 0 END) as start, SUM(CASE when EVENT_ID = 7 then total_count ELSE 0 END) as first_quartile, SUM(CASE when EVENT_ID = 8 then total_count ELSE 0 END) as mid_point, SUM(CASE when EVENT_ID = 9 then total_count ELSE 0 END) as third_quartile, SUM(CASE when EVENT_ID = 10 then total_count ELSE 0 END) as complete, SUM(CASE when EVENT_ID = 11 then total_count ELSE 0 END) as close, SUM(CASE when EVENT_ID = 13 then total_count ELSE 0 END) as viewables,  0 as uniques, SUM(hourly.total_get_from_direct+hourly.attribution_cost_gross) as spend, SUM(hourly.datacost) as datacost, SUM(hourly.attribution_cost_gross) as attribution_cost, SUM(hourly.margin) as margin, SUM(hourly.total_pay_to_pub) as net, SUM(hourly.roi_gross) as roi,SUM(CASE when EVENT_ID = 4 then hourly.roi_gross ELSE 0 END) as roi_1,SUM(CASE when EVENT_ID = 38 then hourly.roi_gross ELSE 0 END) as roi_2,SUM(CASE when EVENT_ID = 39 then hourly.roi_gross ELSE 0 END) as roi_3,SUM(CASE when EVENT_ID = 40 then hourly.roi_gross ELSE 0 END) as roi_4,SUM(CASE when EVENT_ID = 38 then total_count ELSE 0 END) as conversions_2,SUM(CASE when EVENT_ID = 39 then total_count ELSE 0 END) as conversions_3,SUM(CASE when EVENT_ID = 40 then total_count ELSE 0 END) as conversions_4  from " +
      dataStoreRealTimeTable +
      " as hourly " +
      whrCondition +
      ")) A";

    let queriesArr = [
      {
        query: q,
        datasource: "redshift",
      },
    ];

    var availsQuery = "";
    if (reportCampaignIdsSql != "") {
      availsQuery =
        `select SUM(A.available) as available, SUM(A.qualify) as qualify` +
        ` from (( SELECT   SUM(hourly.available) as available,SUM(hourly.qualify) as qualify from neptune.adserv_hourly_realtime_avails as hourly ` +
        ` where  date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}')  AND date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}')  ` +
        ` AND (hourly.\"identity\" IN(${reportCampaignIdsSql}) AND hourly.identitytype IN(1))) ` +
        ` union ` +
        `( SELECT   SUM(hourly.available) as available,SUM(hourly.qualify) as qualify ` +
        `  from neptune.adserv_hourly_realtime_avails_latest as hourly ` +
        ` where  date_time >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}')` +
        ` AND date_time < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}')  ` +
        `AND (hourly.\"identity\" IN(${reportCampaignIdsSql}) AND hourly.identitytype IN(1)) ` +
        `)) A`;

      queriesArr.push({ query: availsQuery, datasource: "redshift" });
    }

    // console.log("Query:", q);
    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        getReportingDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getCampaignAppliedTargetingDataThunk = createAsyncThunk(
  "report/getCampaignAppliedTargetingDataThunk",
  async (payload) => {
    let query =
      "select target_dma,target_brands,target_congressional_districts,target_senate_districts,target_addresses,target_house_districts,target_city,target_state,target_postalcode,target_address_groups,target_ipaddress_groups,target_latlon_groups from " +
      tablePrefix +
      "campaigns_location_groups where campaign_id='" +
      payload.reportCampaignId +
      "'";
    const queryBody = {
      queries: [
        {
          //Get Open Requests Query
          query: query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getStateListDataThunk = createAsyncThunk(
  "report/getStateListDataThunk",
  async (payload) => {
    let query = "SELECT name,country_code,iso2  from " + tablePrefix + "states";
    const queryBody = {
      queries: [
        {
          //Get Open Requests Query
          query: query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getBannerDetailsThunk = createAsyncThunk(
  "company/getBannerDetailsThunk",
  async (payload) => {
    const campaignIds = normalizeReportCampaignIds(payload.campaign_id);
    const bannerWhereClause =
      campaignIds.length > 0
        ? "campaignid IN ('" + campaignIds.join("','") + "')"
        : "campaignid=''";
    const queryBody = {
      queries: [
        {
          query:
            "select id,name,html,imp_type,template_type from " +
            tablePrefix +
            "banners where " +
            bannerWhereClause +
            ";",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getCampaignTargetingTabDataThunk = createAsyncThunk(
  "report/getCampaignTargetingTabDataThunk",
  async (payload) => {
    let query = "";
    if (payload.tab == "target_dma") {
      query =
        "select dma_code,dma_code as id, concat(dma_name,' (DMA)') as name,0 as lat,0 as lng,'dma' as type from " +
        tablePrefix +
        "geodma where dma_code in ('" +
        payload["values"].join("','") +
        "')";
    } else if (payload.tab == "target_brands") {
      query =
        "select id as brand_id,id, name,location_count from " +
        tablePrefix +
        "aggdata.lists where country_code = 'US' and id in ('" +
        payload["values"].join("','") +
        "')";
    } else if (payload.tab == "target_congressional_districts") {
      query =
        "SELECT dm.id AS id,CONCAT(dm.state_name, ' Congressional District ', dm.id) AS name,cn.iso3 as country_code_iso3,dm.latitude as lat,dm.longitude as lng FROM " +
        tablePrefix +
        "congressional_districts dm," +
        tablePrefix +
        "countries cn WHERE dm.id !='' AND dm.country_code=cn.iso2 and cn.iso3  IN('USA') and dm.id in ('" +
        payload["values"].join("','") +
        "')";
    } else if (payload.tab == "target_senate_districts") {
      query =
        "SELECT dm.geo_id AS id,CONCAT(dm.state_code, '-',dm.name) AS name ,dm.latitude as lat,dm.longitude as lng FROM state_legislative_districts dm WHERE dm.geo_id != '' and sld='U' and dm.geo_id in ('" +
        payload["values"].join("','") +
        "')";
    } else if (payload.tab == "target_house_districts") {
      query =
        "SELECT dm.geo_id AS id,CONCAT(dm.state_code, '-',dm.name) AS name ,dm.latitude as lat,dm.longitude as lng FROM " +
        tablePrefix +
        "state_legislative_districts dm WHERE dm.geo_id != '' and sld='L' and dm.geo_id in ('" +
        payload["values"].join("','") +
        "')";
    } else if (payload.tab == "target_state") {
      query =
        "SELECT s.`iso2` AS id, s.name FROM states s,countries c WHERE s.`country_code`=c.iso2 AND c.iso3 in ('" +
        payload["countries"].join("','") +
        "') and s.iso2 in ('" +
        payload["states"].join("','") +
        "')";
    } else if (payload.tab == "target_city") {
      query =
        "SELECT CONCAT(CONCAT(c.iso3, '_', s.`state_code`),'_',s.name) AS id,concat(concat((s.name), ' ', s.state_code)) as name from cities s,countries c  WHERE CONCAT(CONCAT(c.iso3, '_', s.`state_code`),'_',s.name) IN ('" +
        payload["values"].join("','") +
        "')";
    } else if (
      payload.tab == "target_postalcode" ||
      payload.tab == "target_latlon_groups" ||
      payload.tab == "target_ipaddress_groups" ||
      payload.tab == "target_address_groups"
    ) {
      query =
        "SELECT id,name from targeting_groups where type='" +
        payload.groupType +
        "' and id IN ('" +
        payload["values"].join("','") +
        "')";
    }
    const queryBody = {
      queries: [
        {
          query: query,
          datasource:
            payload.tab == "target_brands"
              ? "redshift"
              : DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getPincodeDetailsDataThunk = createAsyncThunk(
  "report/getPincodeDetailsDataThunk",
  async (payload) => {
    let query =
      "SELECT p.name as zipcode,p.latitude,p.longitude,p.short_state,c.iso3 as country  from " +
      tablePrefix +
      "postalcodes as p, " +
      tablePrefix +
      "countries as c WHERE p.country_code=c.iso2 " +
      " AND p.name IN ('" +
      payload["pincodes"].join("','") +
      "') and c.iso3 IN('" +
      payload["countries"].join("','") +
      "')";

    const queryBody = {
      queries: [
        {
          //Get Open Requests Query
          query: query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetCampaignReportByRegionIDDataThunk = createAsyncThunk(
  "report/GetCampaignReportByRegionIDDataThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        getRegionIDReportingDataEndPoint,
        payload
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const { actions, reducer } = CampaignAllReport;
export const { updateTabLoaders, sortCreativesData, resetReportingData } =
  actions;
export default reducer;
